import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import axios from "axios";
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";


const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;


var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;



const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xls';

const exportToCSV = (csvData, fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [['Sr No', 'Warehouse-Brand', 'Movement Type', 'From Bin', 'To Bin', 'Quantity', 'User']];
  const ws = XLSX.utils.json_to_sheet(csvData, { origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xls', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
}


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchStockMovementData = this.fetchStockMovementData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      product_code: "",
      movement_type: "",
      movement_list: "",

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      from_date: "",
      to_date: "",
      mrp: "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData: [],
      batch_id: "",
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""

    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
    this.getMovementTypeList();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };


  onMrpChange = (evt) => {
    this.setState({
      mrp: evt.target.value,
    });
  };

  onProductChange = (evt) => {
    this.setState({
      product_code: evt.target.value,
    });
  };
  onMovementChange = (evt) => {
    this.setState({
      movement_type: evt.target.value,
    })
  }

  getMovementTypeList() {
    API.get('/stock/fetchMovementList')
      .then(response => response.data)
      .then(data => {
        this.setState({
          movement_list: data.list
        })
      })
      .then(async () => {
        this.setState({ isLoading: false, loading_overlay: false })
      });
  }

  fetchStockMovementData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      fromdate: From_Date_val,
      todate: to_Date_val,
      product_code: this.state.product_code,
      mrp: this.state.mrp,
      movement_type: this.state.movement_type,

    };
    API.post('/stock/fetchStockMovementReport', { param: payload })
      .then(response => response.data)

      .then(data => {

        this.setState({ tableRows: this.assemblePosts(data.data) })

      })

      .then(async () => {

        this.setState({ isLoading: false, loading_overlay: false })



      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {
          sr_no: post.sr_no,
          warehouse: post.warehouse,
          movement_type: post.movement_type,
          from_bin: post.from_bin,
          to_bin: post.to_bin,
          quantity: post.quantity,
          user: post.user

        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts,
      orderData: posts,
      filtered_orderData: posts
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {

    const data = {

      columns: [
        {
          label: 'Sr No.',
          field: 'sr_no',
          sort: 'asc',
          width: 80,

        },
        {
          label: 'Warehouse-Brand',
          field: 'warehouse',
          sort: 'asc',
          width: 140,

        },
        {
          label: 'Movement Type',
          field: 'movement_type',
          sort: 'asc',
          width: 140,

        },
        {

          label: 'From Bin',
          field: 'from_bin',
          width: 140,
          sort: 'asc',

        },
        {
          label: 'To Bin',
          field: 'to_bin',
          sort: 'asc',
          width: 140,

        },

        {
          label: 'Quantity',
          field: 'quantity',
          width: 140,
          sort: 'asc',

        },
        {

          label: 'User',
          field: 'user',
          width: 140,
          sort: 'asc',

        },


      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <CardBody style={{ paddingTop: 22, height: 100, marginTop: "-20px", paddingBottom: 0 }}>
            <form className="form" >

              <div style={{ width: '15%', marginBottom: '0px', float: 'left', marginRight: 5 }}>

                <DatePicker
                  selected={this.state.from_date}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format='yyyy-MM-dd'

                />

                {this.state.showFromErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                }
                {this.state.dateOrderError && (
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                )}
              </div>

              <div style={{ width: '15%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <DatePicker
                  selected={this.state.to_date}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="To Date"
                />
                {this.state.showToErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                }

                {this.state.dateRangeError &&
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                }

              </div>
              <div
                style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}
              >
                <div
                  className="form__form-group-field"

                >
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Product Code" onChange={this.onProductChange} />
                </div>
              </div>
              <div
                style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}
              >
                <div
                  className="form__form-group-field"

                >
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Mrp" onChange={this.onMrpChange} />
                </div>
              </div>
              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px", }}
              >
                <div
                  className="form__form-group-field"

                >
                  <select
                    className="form-control select_style"
                    style={{ fontSize: 13, width: 250, marginRight: 10, marginLeft: 0 }}
                    onChange={this.onMovementChange}

                  >
                    <option value="">Movement Type</option>
                    {this.state.movement_list &&
                      this.state.movement_list.length > 0 &&
                      this.state.movement_list.map((item) => {
                        return (
                          <option value={item.type}>
                            {" "}
                            {item.type}
                          </option>
                        );
                      })}

                  </select>
                </div>
              </div>


              <div style={{ width: '9%', marginBottom: '0px', marginLeft: "60px", float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchStockMovementData()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
                </ButtonToolbar>
              </div>
              <div style={{ width: '6%', marginBottom: '0px', float: 'left' }}>
                <Button type="button" className="btn btn-primary-outline"
                  style={{
                    cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                    backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                  }}
                  id="button_enable"
                // onClick={this.downloadReport}
                >

                  {/* <img src={require('../../../../images/download.png')} onClick={this.state.downloadError} /> */}
                  <img src={require('../../../../images/download.png')} onClick={(e) => exportToCSV(this.state.filtered_orderData, "Integration Report")} />
                </Button>
              </div>

            </form>
          </CardBody>
          {
            this.state.showFetchBinData && (

              <CardBody style={{ marginTop: 5 }}>
                <div className="table_header" style={{ borderBottomWidth: '0px' }}>

                  <h4 style={{ fontWeight: 'bold', width: '80%', paddingTop: 10, float: 'left' }} className="subhead red-text">Reports</h4>

                </div>
                <hr style={{ marginTop: '30px', marginBottom: '0px' }} />
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={data}
                // style={{ textAlign: "center" }}
                />
              </CardBody>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));